export function isMobile(): boolean {
    // __IS_MOBILE_VERSION__ is only defined on build for improved tree shaking
    // vite build will remove code, that is wrapped inside an if statement:
    // if (isMobile()) {...} for desktop
    // if (!isMobile()) {...} for mobile
    if (typeof __IS_MOBILE_VERSION__ !== "undefined") {
        return __IS_MOBILE_VERSION__
    }
    return SiteInfo.isMobileVersion
}

export function isPC() {
    return !isMobile()
}

export function setIsMobile(isMobile = true) {
    if (typeof __IS_MOBILE_VERSION__ !== "undefined") {
        __IS_MOBILE_VERSION__ = isMobile
    }
}
